export default __webpack_public_path__ + "static/media/00-fish-bike.43856989.webp";